// 酒店管理路由
export default {
    path: 'hotel',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '酒店管理'},
    children: [
        //酒店列表
        {
            path: 'list',
            component: () => import('@/views/hotel/list'),
            meta: { title: '酒店列表'},
			props: true
        },
		//酒店订单列表
		{
		    path: 'order',
		    component: () => import('@/views/hotel/order'),
		    meta: { title: '订单列表'},
			props: true
		}
    ]
};
